import React, { useMemo } from 'react';
import { Row, Col, Grid } from 'antd'
import { COLOR, FONT } from '../constants';
import _ from 'lodash';
import TNContent from './TNContent';

const META_LIST = {
  upper: [{
    label: 'Collection Title',
    value: 'Shiba9',
    span: { xs: 14, sm: 14, md: 14, lg: 7 }
  },
  {
    label: 'Created By',
    value: 'NineBlocks',
    span: { xs: 12, sm: 12, md: 12, lg: 7 }
  },
  {
    label: 'Blockchain',
    value: 'Solana',
    span: { xs: 12, sm: 12, md: 12, lg: 6 }

  }],

  lower: [
    // {
    //   label: 'Token standard',
    //   value: 'ERC-721',
    //   span: { xs: 14, sm: 14, md: 14, lg: 7 }

    // },
    {
      label: 'Supply',
      value: '3333',
      span: { xs: 12, sm: 12, md: 12, lg: 5 }

    },
    {
      label: 'Metadata',
      value: '8 Attributes',
      span: { xs: 14, sm: 14, md: 14, lg: 7 }
    },
    {
      label: 'Creator Fees',
      value: '5%',
      span: { xs: 14, sm: 14, md: 14, lg: 6 }

    },
  ]
}

const CollectionInfo = () => {
  const screens = Grid.useBreakpoint();

  const isMobile = useMemo(() => {
    return !screens.md;
  }, [screens.md])

  return (
    <TNContent maxWidth={1920}>
      <Row
        style={{
          backgroundImage: "url('./assets/bg_collection_info.png')",
          backgroundPosition: isMobile ? 'left' : 'right',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          height: '100%',
          width: '100%',
          padding: '7%'
        }}
        align="bottom"
      >
        <Col xs={24} sm={24} md={24} lg={13} xl={13} style={{ zIndex: 2 }}>
          <Row gutter={[0, 24]}>
            <Col span={24}>
              <img src="./assets/star.svg" alt="" style={{ width: 40, marginRight: 10 }} />
              <span style={{ ...FONT.h5, color: COLOR.background }}>About</span>
            </Col>
            <Col span={24}>
              <span style={{ ...FONT.h3, color: COLOR.heading }}>Proudly present our first NFT collection </span>
            </Col>
            <Col span={24}>
              <p style={{ ...FONT.text, color: COLOR.text }}>
                Inspired by the slang “IT dog” to describe IT peers in Hong Kong, technine was named and established in 2019. We’ve been growing at lightning speed and are now launching NineBlocks, a brand to bring blockchain technology into use to welcome the web3 era.
              </p>
              <p style={{ ...FONT.text, color: COLOR.text }}>
                Shiba9 combines the lovable Shiba and the iconic waving cat, which represent the birth of technine, as well as our warm wishes to all the NFT owners for strength, good luck and good health.
              </p>
            </Col>
            <Col span={24}>
              <Row gutter={[24, 24]} justify="start" style={{ marginBottom: 20 }}>
                {_.map(META_LIST.upper, (item) => {
                  return <MetaItem key={item.value} style={{ marginRight: 20 }} label={item.label} value={item.value} span={item.span} />
                })}
              </Row>
              <Row gutter={[24, 24]}>
                {_.map(META_LIST.lower, (item) => {
                  return <MetaItem key={item.value} style={{ marginRight: 20 }} label={item.label} value={item.value} span={item.span} />
                })}
              </Row>
            </Col>
          </Row>
        </Col>

        <Col xs={0} sm={0} md={0} lg={11} xl={11}>
          <img src="./assets/collection_nft.png" alt="" style={{ width: '100%', objectFit: 'cover', transform: 'scale(1.4)', marginLeft: -35, zIndex: -1 }} />
        </Col>
      </Row>
    </TNContent>
  )
}

const MetaItem = ({
  label,
  value,
  span,
  style
}) => {
  return (
    <Col {...span} style={{
      border: '4px solid #000000', boxShadow: '6px 7px 0px #000000', borderRadius: 8, backgroundColor: COLOR.background,
      ...style,
      //  marginRight: 5
    }}>
      <div style={{ padding: 10 }}>
        <p style={{ ...FONT.h6, color: COLOR.captionText }}>{label}: </p>
        <span style={{ ...FONT.h5, color: COLOR.heading, borderBottom: `2px solid ${COLOR.menuText}` }}>{value}</span>
      </div>
    </Col>
  )
}

export default CollectionInfo;